import { UsuarioPermissaoEnum, UsuarioPermissaoFlags } from './../../utils/enums/UsuarioPermissaoEnums';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { take, map, catchError } from 'rxjs/operators';
import { DadosUsuarioService } from 'src/app/services/dados-usuario.service';
import { UsuarioBeneficioService } from 'src/app/services/usuario-beneficio.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ImageTransform, ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { HttpResponse } from '@angular/common/http';
import { FileDownloadService } from '@services/file-download.service';
import { HomeService } from '@services/home.service';
import { ToastrService } from 'ngx-toastr';
import { ParametroSistemaService } from '@services/parametro-sistema.service';
import { AtributosService } from '@services/atributos.service';
import { EMAIL_REGEX } from '@utils/html-sanitizer.util';
import { combineLatest, of } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../../components/success-generico/success-generico.component';
import { AlertRefazerRotaComponent } from '../dados-usuario-rota-inteligente/alert-refazer-rota/alert-refazer-rota.component';
import { AlertPerguntaComponent } from '../dados-usuario-rota-inteligente/alert-pergunta/alert-pergunta.component';
import { AlertErroCustomizadoComponent } from '../../components/alert-erro-customizado/alert-erro-customizado.component';
import { AlertNovoDepartamentoComponent } from '../../components/alert-novo-departamento/alert-novo-departamento.component';
import { AlertNovoCargoComponent } from '../../components/alert-novo-cargo/alert-novo-cargo.component';
import { AlertNovoEnderecoComponent } from '../../components/alert-novo-endereco/alert-novo-endereco.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { NgxMaskDirective } from 'ngx-mask';
import { SelectComponent } from '../../components/select/select.component';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { MatTooltip } from '@angular/material/tooltip';
import { ApiStateComponent } from '../../components/api-state/api-state.component';
import { ConfirmaExclusaoComponent } from '../dados-empresa/confirma-exclusao/confirma-exclusao.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-dados-usuario',
    templateUrl: './dados-usuario.component.html',
    styleUrls: ['./dados-usuario.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, SuccessGenericoComponent, AlertRefazerRotaComponent, AlertPerguntaComponent, AlertErroCustomizadoComponent, AlertNovoDepartamentoComponent, AlertNovoCargoComponent, AlertNovoEnderecoComponent, NgClass, BreadcrumbComponent, FormsModule, ReactiveFormsModule, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgxMaskDirective, SelectComponent, PopoverDirective, RouterLink, MatTooltip, ApiStateComponent, ImageCropperComponent, ConfirmaExclusaoComponent, FooterComponent, AsyncPipe, UsuarioPermissaoPipe]
})
export class DadosUsuarioComponent implements OnInit {

  idEmpresaLogada = localStorage.idEmpresaLogada;
  abaSelecionada = 1;
  idUsuario = 0;
  fotoUsuario: any;
  dadosUsuario: any;
  edicaoUsuario: any = false;
  formularioAba1: UntypedFormGroup;
  formularioAba2: UntypedFormGroup;
  // VARIAVEIS DE CONSULTA DE CEP
  consultaCepTrabalho: any = undefined;
  consultaCepResidencia: any = undefined;
  // ARRAYS DE INFORMAÇOES NECESSARIAS
  estadosUf: any = null;
  departamentos: any = null;
  cargos: any = null;
  enderecos: any = null;
  enderecosOptions: any = null;
  fotoSelecionada: any = undefined;
  nomeArquivo: string;
  statusApiFoto: any = undefined;
  file: FormData = new FormData();
  // PARTE DE BENEFICIOS
  beneficios: any = null;
  valorTotalBeneficio: any;
  diasTrabalhados: any = null;
  campoInputBeneficio: string;
  listaNomesBeneficios: any = undefined;
  listaNomesBeneficiosOptions: any = undefined;
  formularioBeneficio: UntypedFormGroup;
  mensagemErroBeneficio = '';
  idBeneficioParaExcluir: number;
  edicaoBeneficioAtiva = false;
  beneficioSelecionadoEditar: any;

  // ALERTS PARA ABRIR OS MODAIS VARIAVEIS
  alertIncluirDepartamento = false;
  alertIncluirCargo = false;
  alertIncluirEndereco = false;
  alertIncluirFoto = false;
  alertConfirmacao = false;
  // ALERTS FINAIS
  alertLoading = false;
  alertSucesso = false;
  alertError = false;
  alertPergunta = false;
  mensagemErro = '';
  alertAprovarRotaInteligente = false;
  detalheRoteirizacao: any = null;
  mensagemErroRotaInteligente = '';

  habilitaBotaoSalvar = false;
  arquivo: any;
  tamanhoFoto: any = 1;
  imageFile: any;
  imageChangedEvent: any = '';
  transform: ImageTransform = {};
  scale = 0.1;
  showCropper = false;
  croppedImage: any = '';
  tamanhoInicio = 1;

  // DATA NASCIMENTO VALIDACAO
  dataNascimentoInvalida = '';
  tituloMensagemErro: string;
  errorNumeroEndereco: boolean;
  listaExtensoes: any;
  extensaoArquivo: any;
  comparador: any;
  loadingDados: boolean;
  unicaOpcaoBeneficio: any;

  chavePix: string;
  tipoChave: string;
  colorChave: string;
  pixUsuarioHabilitado = false;

  constructor(
    private readonly service: DadosUsuarioService,
    private readonly usuarioBeneficioService: UsuarioBeneficioService,
    private readonly formularioBuilder: UntypedFormBuilder,
    public rota: Router,
    public rotaAtiva: ActivatedRoute,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly homeService: HomeService,
    private readonly Toastr: ToastrService,
    private readonly parametroService: ParametroSistemaService,
    private readonly atributosService: AtributosService) {
  }

  ngOnInit() {
    this.constroiFormularioBeneficio();
    this.consultaUfs();
    this.consultaDepartamentos();
    this.consultaCargos();
    this.consultaEnderecos();
    this.getListaExtensoes();
    this.getPixUsuarioHabilitado();
    this.rotaAtiva.params.subscribe(async (data: any) => {
      if ((data.idUsuario || this.idUsuario) && (UsuarioPermissaoFlags.Alterar && UsuarioPermissaoFlags.Imprimir)) {
        this.loadingDados = true;
        this.idUsuario = data.idUsuario;
        this.edicaoUsuario = true;
        this.consultaBeneficiosDoUsuario();
        await this.consultaDadosUsuario();
        this.travaForm();
        this.consultaFotoUsuario();
        this.getListaExtensoes();
      } else if (UsuarioPermissaoFlags.Incluir) {
        this.constroiFormulario();
      } else {
        this.rota.navigate(['usuario-beneficio']);
      }
    });
    if (sessionStorage.abaBeneficio) {
      this.abaSelecionada = 3;
      sessionStorage.removeItem('abaBeneficio');
    }
  }

  public travaForm() {
    this.usuarioPermissaoService.usuarioPermissoes$.subscribe(() => {
      const permissao2Via = this.usuarioPermissaoService.verificarPermissao
      (UsuarioPermissaoEnum.UsuariosDeBeneficioSolicitacao2aVia.menuId, UsuarioPermissaoFlags.Imprimir);
      const usuarioBenefico = this.usuarioPermissaoService.verificarPermissao
      (UsuarioPermissaoEnum.CadastrosUsuariosDeBeneficio.menuId, UsuarioPermissaoFlags.Alterar);
      if (usuarioBenefico) {
        this.formularioAba1.enable();
        this.formularioAba2.enable();
      } else if (permissao2Via) {
        this.formularioAba1.disable();
        this.formularioAba2.disable();
      }

    });
  }

  consultaDadosUsuario() {
    return new Promise<void>(res => {
      this.usuarioBeneficioService.getUserByCompany(this.idEmpresaLogada, this.idUsuario)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            this.dadosUsuario = response.response;
            this.constroiFormulario();
            this.loadingDados = false;
          } else {
            this.dadosUsuario = false;
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.dadosUsuario = false;
        },
        complete: () => {
          res();
        }
      });
    });
  }

  consultaFotoUsuario() {
    this.fotoUsuario = '';
    this.service.getPhotoUsuario(this.idUsuario).subscribe(fotoUsuario => {
      this.fotoUsuario = fotoUsuario;
    });
  }

  alterarAba(numero: number) {
    window.scrollTo(0, 0);
    this.abaSelecionada = numero;
  }

  constroiFormulario() {
    const { userSalario, userRG } = this.getDadosEdicao();
    this.formularioAba1 = this.constroiFormularioAba1(userSalario, userRG);
    this.formularioAba2 = this.constroiFormularioAba2();
  }

  private getDadosEdicao(): { userSalario: number, userRG: string } {
    let userSalario = 0;
    let userRG = '';

    if (this.edicaoUsuario) {
      userSalario = this.dadosUsuario?.valorSalario == null
        ? 0
        : this.dadosUsuario.valorSalario.toLocaleString('pt-BR', {minimumFractionDigits: 2});

      userRG = this.dadosUsuario?.codigoRg == null
        ? ''
        : `${this.dadosUsuario.codigoRg}${this.dadosUsuario.codigoDigitoRG}`;

      this.verificaHorasIdade(this.dadosUsuario.dataNascimento);
    }
    return { userSalario, userRG };
  }

  private constroiFormularioAba1(userSalario: number, userRG: string): UntypedFormGroup {
    const d = this.dadosUsuario;
    return this.formularioBuilder.group({
      matricula:     [d?.codigoUsuario ?? ''],
      nomeCompleto:  [d?.nomeUsuario ?? '', Validators.compose([Validators.pattern('^([A-Za-zà-üÀ-Ü0-9\\.\\ \\\'-]*)$')])],
      dataNascimento:[d?.dataNascimento ?? '', Validators.compose([Validators.required])],
      cpf:           [d?.codigoCpf ?? '', Validators.compose([Validators.required])],
      rg:            [userRG],
      uf:            [d?.codigoEmissaoEstado ?? 'S'],
      genero:        [d?.flagSexo ?? '', Validators.compose([Validators.required])],
      nomeMae:       [d?.nomeNomeMae ?? '', Validators.compose([Validators.pattern('^([A-Za-zà-üÀ-Ü0-9\\.\\ \\\'-]*)$')])],
      situacao:      [d?.flagAtivo ?? 'S'],
      salario:       [d ? userSalario : 0],
      email:         [d?.email ?? '', Validators.compose([Validators.email])],
      celular:       [d?.ddd && d?.celular ? `${d.ddd}${d.celular}` : ''],
      codBanco:      [d?.codigoBanco ?? ''],
      codAgencia:    [d?.codigoAgencia ?? ''],
      digAgencia:    [d?.codigoDigitoAgencia ?? ''],
      ctaCorrente:   [d?.codigoNumeroContaCorrente ?? ''],
      digCC:         [d?.codigoDigitoContaCorrente ?? ''],
      chavePix:      [d?.chavePix ?? '']
    });
  }

  private constroiFormularioAba2(): UntypedFormGroup {
    const d = this.dadosUsuario;
    const t = d?.enderecoTrabalho;
    const r = d?.enderecoResidencial;
    return this.formularioBuilder.group({
      departamento:          [d?.idDepartamento ?? '', Validators.compose([Validators.required])],
      cargo:                 [d?.idCargo ?? '', Validators.compose([Validators.required])],
      localEntrega:          [d?.idEndereco ?? '', Validators.compose([Validators.required])],
      cepTrabalho:           [t?.codigoCep ?? ''],
      logradouroTrabalho:    [t?.descricaoLogradouro ?? ''],
      numeroTrabalho:        [t?.codigoNumero ?? ''],
      complementoTrabalho:   [t?.codigoComplemento ?? ''],
      bairroTrabalho:        [t?.codigoBairro ?? ''],
      cidadeTrabalho:        [t?.codigoCidade ?? ''],
      ufTrabalho:            [t?.codigoEstado ?? ''],
      cepResidencia:         [r?.codigoCep ?? ''],
      logradouroResidencia:  [r?.descricaoLogradouro ?? ''],
      numeroResidencia:      [r?.codigoNumero ?? ''],
      complementoResidencia: [r?.codigoComplemento ?? ''],
      bairroResidencia:      [r?.codigoBairro ?? ''],
      cidadeResidencia:      [r?.codigoCidade ?? ''],
      ufResidencia:          [r?.codigoEstado ?? ''],
    });
  }

  constroiFormularioBeneficio() {
    this.formularioBeneficio = this.formularioBuilder.group({
      idPeriodo: [0],
      idProduto: ['', Validators.compose([Validators.required])],
      qtdeDias: ['', Validators.compose([Validators.required])],
      valorItem: ['', Validators.compose([Validators.required])],
      qtdeDiasTrabalhados: ['', Validators.compose([Validators.required])],
    });
  }

  // CONSULTA DE INFORMAÇOES NECESSÝRIAS
  consultaUfs() {

    this.estadosUf = null;
    this.service.getAllUfs().pipe(take(1)).subscribe({
      next: (response: any) => {
        this.estadosUf = response.response;
      },
      error: (erro: any) => {
        this.estadosUf = false;
        console.error(erro);
      }
    });

  }

  consultaDepartamentos() {
    this.departamentos = null;
    this.service.getAllDepartamentos(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.departamentos = response.response;
      },
      error: (error) => {
        this.departamentos = false;
        console.error(error);
      }
    });
  }

  consultaCargos() {
    this.cargos = null;
    this.service.getAllCargos(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.cargos = response.response;
      },
      error: (error) => {
        this.cargos = false;
        console.error(error);
      }
    });
  }

  consultaEnderecos() {
    this.enderecos = null;
    this.service.getAllEnderecos(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.enderecos = response.response;
        this.enderecosOptions = this.enderecos.map((endereco) => {
          const complemento = (endereco.codigoComplemento ?? '').trim() ? ` (${endereco.codigoComplemento})` : '';
          return {
            value: endereco.idEndereco,
            description: `${endereco.descricaoLogradouro}, ${endereco.codigoNumero}${complemento},
             ${endereco.codigoBairro}, ${endereco.codigoCidade} - ${endereco.codigoEstado} | ${endereco.codigoCep}`
          };
        });
      },
      error: (error: any) => {
        this.enderecos = false;
        console.error(error);
      }
    });
  }

  replicarEndereco(input: any) {
    if (!input.checked) {
      (document.getElementById('logradouroTrabalho') as HTMLInputElement).readOnly = true;
      (document.getElementById('bairroTrabalho') as HTMLInputElement).readOnly = true;
    }
    if (input.checked && this.formularioAba2.value.localEntrega) {
      const idPraSerReplicado = Number(this.formularioAba2.value.localEntrega);
      const enderecoSelecionado = this.enderecos.find(endereco => endereco.idEndereco === idPraSerReplicado);

      this.formularioAba2.patchValue({
        cepTrabalho: enderecoSelecionado.codigoCep,
        logradouroTrabalho: enderecoSelecionado.descricaoLogradouro,
        numeroTrabalho: enderecoSelecionado.codigoNumero,
        complementoTrabalho: enderecoSelecionado.codigoComplemento,
        bairroTrabalho: enderecoSelecionado.codigoBairro,
        cidadeTrabalho: enderecoSelecionado.codigoCidade,
        ufTrabalho: enderecoSelecionado.codigoEstado,
      });
      const logradouroVazio = JSON.stringify(this.formularioAba2.value.logradouroTrabalho) === 'null'
        || this.formularioAba2.value.logradouroTrabalho.trim() === '';

      const logradouroInput = document.getElementById('logradouroTrabalho') as HTMLInputElement;
      logradouroInput.readOnly = !logradouroVazio;

      const bairroVazio = JSON.stringify(this.formularioAba2.value.bairroTrabalho) === 'null'
        || this.formularioAba2.value.bairroTrabalho.trim() === '';

      const bairroInput = document.getElementById('bairroTrabalho') as HTMLInputElement;
      bairroInput.readOnly = !bairroVazio;

      (document.getElementById('cidadeTrabalho') as HTMLInputElement).readOnly = true;
      (document.getElementById('ufTrabalho') as HTMLInputElement).readOnly = true;

    } else {
      this.formularioAba2.patchValue({
        cepTrabalho: '',
        logradouroTrabalho: '',
        numeroTrabalho: '',
        cepTrabcomplementoTrabalhoalho: '',
        bairroTrabalho: '',
        cidadeTrabalho: '',
        ufTrabalho: ''
      });
      this.consultaCepTrabalho = undefined;
    }
  }

  consultarCep(tipoCep: string) {

    if (tipoCep === 'cepTrabalho') {
      if (this.formularioAba2.value.cepTrabalho.length) {
        this.consultaCepTrabalho = null;

        this.service.searchCep(this.formularioAba2.value.cepTrabalho)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            if (response.status === 'OK') {
              this.consultaCepTrabalho = true;
              this.formularioAba2.patchValue({
                bairroTrabalho: response.response.bairro,
                cidadeTrabalho: response.response.cidade,
                ufTrabalho: response.response.estado,
                logradouroTrabalho: response.response.logradouro,
                complementoTrabalho: '',
                numeroTrabalho: ''
              });

              const logradouroVazio = JSON.stringify(this.formularioAba2.value.logradouroTrabalho) === 'null'
                || this.formularioAba2.value.logradouroTrabalho === undefined
                || this.formularioAba2.value.logradouroTrabalho.trim() === '';
              (document.getElementById('logradouroTrabalho') as HTMLInputElement).readOnly = !logradouroVazio;

              const bairroVazio = JSON.stringify(this.formularioAba2.value.bairroTrabalho) === 'null'
                || this.formularioAba2.value.bairroTrabalho === undefined
                || this.formularioAba2.value.bairroTrabalho.trim() === '';
              (document.getElementById('bairroTrabalho') as HTMLInputElement).readOnly = !bairroVazio;
              (document.getElementById('cidadeTrabalho') as HTMLInputElement).readOnly = true;
              (document.getElementById('ufTrabalho') as HTMLInputElement).readOnly = true;
            } else {
              this.consultaCepTrabalho = false;
            }
          },
          error: (erro: any) => {
            this.consultaCepTrabalho = false;
            console.error(erro);
          }
        });
      }
    } else if (this.formularioAba2.value.cepResidencia.length) {
        this.consultaCepResidencia = null;

        this.service.searchCep(this.formularioAba2.value.cepResidencia)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            if (response.status === 'OK') {
              this.consultaCepResidencia = true;
              this.formularioAba2.patchValue({
                bairroResidencia: response.response.bairro,
                cidadeResidencia: response.response.cidade,
                ufResidencia: response.response.estado,
                logradouroResidencia: response.response.logradouro,
                complementoResidencia: '',
                numeroResidencia: ''
              });

              const logradouroVazio = JSON.stringify(this.formularioAba2.value.logradouroResidencia) === 'null'
                || this.formularioAba2.value.logradouroResidencia === undefined
                || this.formularioAba2.value.logradouroResidencia.trim() === '';

              const logradouroInput = document.getElementById('logradouroResidencia') as HTMLInputElement;
              logradouroInput.readOnly = !logradouroVazio;

              const bairroVazio = JSON.stringify(this.formularioAba2.value.bairroResidencia) === 'null'
                || this.formularioAba2.value.bairroResidencia === undefined
                || this.formularioAba2.value.bairroResidencia.trim() === '';

              const bairroInput = document.getElementById('bairroResidencia') as HTMLInputElement;
              bairroInput.readOnly = !bairroVazio;

              (document.getElementById('cidadeResidencia') as HTMLInputElement).readOnly = true;
              (document.getElementById('ufResidencia') as HTMLInputElement).readOnly = true;
            } else {
              this.consultaCepResidencia = false;
            }
          },
          error: (error: any) => {
            this.consultaCepResidencia = false;
            console.error(error);
          }
        });
      }
  }

  // Restar as informacoes do CEP quando apagar tudo
  resetaCep() {
    if (!this.formularioAba2.value.cepTrabalho) {
      this.formularioAba2.patchValue({
        bairroTrabalho: '',
        cidadeTrabalho: '',
        ufTrabalho: '',
        logradouroTrabalho: '',
        numeroTrabalho: '',
        complementoTrabalho: '',
      });
    }

    if (!this.formularioAba2.value.cepResidencia) {
      this.formularioAba2.patchValue({
        bairroResidencia: '',
        cidadeResidencia: '',
        ufResidencia: '',
        logradouroResidencia: '',
        complementoResidencia: '',
        numeroResidencia: ''
      });
    }
  }

  adicionarUsuario() {
    this.mensagemErroRotaInteligente = '';
    this.errorNumeroEndereco = false;
    const objUsuario = {
      codigoAgencia: this.formularioAba1.value.codAgencia,
      codigoBanco: this.formularioAba1.value.codBanco,
      codigoDigitoAgencia: this.formularioAba1.value.digAgencia,
      codigoDigitoContaCorrente: this.formularioAba1.value.digCC,
      codigoNumeroContaCorrente: this.formularioAba1.value.ctaCorrente,
      cpf: this.formularioAba1.value.cpf,
      dataNascimento: this.formularioAba1.value.dataNascimento,
      digitoRG: this.formularioAba1.value.rg.substr(this.formularioAba1.value.rg.length - 1),
      email: this.formularioAba1.value.email,
      enderecoTrabalho: {
        codigoBairro: this.formularioAba2.value.bairroTrabalho,
        codigoCep: this.formularioAba2.value.cepTrabalho,
        codigoCidade: this.formularioAba2.value.cidadeTrabalho,
        codigoComplemento: this.formularioAba2.value.complementoTrabalho,
        codigoEstado: this.formularioAba2.value.ufTrabalho,
        codigoNumero: this.formularioAba2.value.numeroTrabalho,
        descricaoLogradouro: this.formularioAba2.value.logradouroTrabalho,
        idEndereco: 0
      },
      estadoEmissao: this.formularioAba1.value.uf,
      flagAtivo: this.formularioAba1.value.situacao,
      flagSexo: this.formularioAba1.value.genero,
      idCargo: this.formularioAba2.value.cargo,
      idDepartamento: this.formularioAba2.value.departamento,
      idEnderecoEntrega: this.formularioAba2.value.localEntrega,
      idUsuario: this.idUsuario,
      matricula: this.formularioAba1.value.matricula,
      nomeCompleto: this.formularioAba1.value.nomeCompleto,
      nomeMae: this.formularioAba1.value.nomeMae,
      numeroRG: this.formularioAba1.value.rg.substring(0, this.formularioAba1.value.rg.length - 1),
      residencia: {
        bairro: this.formularioAba2.value.bairroResidencia,
        cep: this.formularioAba2.value.cepResidencia,
        cidade: this.formularioAba2.value.cidadeResidencia,
        complemento: this.formularioAba2.value.complementoResidencia,
        estado: this.formularioAba2.value.ufResidencia,
        idEndereco: 0,
        logradouro: this.formularioAba2.value.logradouroResidencia,
        numero: this.formularioAba2.value.numeroResidencia,
        numeroMatricula: this.formularioAba1.value.matricula,
      },
      telefone: {
        ddd: this.formularioAba1.value.celular?.slice(0, 2),
        ddi: '55',
        idTelefone: 0,
        idTipoTel: 0,
        numero: this.formularioAba1.value.celular?.slice(2),
      },
      valorSalario: this.formularioAba1.value.salario.length ? this.formularioAba1.value.salario.replace(/\./g, '').replace(',', '.') : 0,
      chavePix: this.formularioAba1.value.chavePix
    };

    this.alertLoading = true;
    (document.getElementById('logradouroResidencia') as HTMLInputElement).readOnly = true;
    (document.getElementById('bairroResidencia') as HTMLInputElement).readOnly = true;
    (document.getElementById('bairroTrabalho') as HTMLInputElement).readOnly = true;
    (document.getElementById('logradouroTrabalho') as HTMLInputElement).readOnly = true;
    if (objUsuario.residencia.cep !== null) {
      if (objUsuario.residencia.cep.length > 0 && objUsuario.residencia.numero.length === 0) {
        this.alertLoading = false;
        this.alertError = true;
        this.tituloMensagemErro = 'Erro ao adicionar usuário!';
        this.mensagemErro = 'Favor preencher o campo número do endereço da residência.';
        this.errorNumeroEndereco = true;
      }
    }
    if (objUsuario.enderecoTrabalho.codigoCep != null) {
      if (objUsuario.enderecoTrabalho.codigoCep.length > 0 && objUsuario.enderecoTrabalho.codigoNumero.length === 0) {
        this.alertLoading = false;
        this.alertError = true;
        this.tituloMensagemErro = 'Erro ao adicionar usuário!';
        this.mensagemErro = 'Favor preencher o campo número do endereço de trabalho.';
        this.errorNumeroEndereco = true;
      }
    }
    if (objUsuario.flagSexo === null || objUsuario.flagSexo === '') {
      this.alertLoading = false;
      this.alertError = true;
      this.tituloMensagemErro = 'Erro ao adicionar usuário!';
      this.mensagemErro = 'Favor preencher o campo gênero nos dados pessoais.';
      this.errorNumeroEndereco = true;
    }
    if (!this.errorNumeroEndereco) {
      this.service.createUsuario(this.idEmpresaLogada, objUsuario)
        .subscribe({
          next: (response: any) => {
            this.alertLoading = false;
            if (response.status === 'OK') {
              this.alertSucesso = true;
              this.idUsuario = response.response.idUsuario;
              this.habilitaBotaoSalvar = false;
              this.mensagemErro = '';
            }
            if (response.status === 'NOK') {
              this.alertLoading = false;
              this.alertError = true;
              this.tituloMensagemErro = 'Erro ao adicionar usuário!';
              this.mensagemErro = response.mensagem;
            }
          },
          error: (erro: any) => {
            this.alertLoading = false;
            this.alertError = true;
            this.tituloMensagemErro = 'Erro ao adicionar usuário!';
            this.mensagemErro = erro.error.mensagem;
          }
        });
    }
  }

  abrirAlertIncluirFoto() {
    this.alertIncluirFoto = true;
  }

  habilitaBotao() {
    this.habilitaBotaoSalvar = true;
  }

  cancelarAlertIncluirFoto() {
    this.alertIncluirFoto = false;
  }

  enviarFoto() {
    this.file.set('file', this.imageFile);
    this.statusApiFoto = null;
    this.service.uploadPhotoUsuario(this.idUsuario, this.file).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.statusApiFoto = true;
          this.consultaFotoUsuario();
        } else {
          this.statusApiFoto = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.statusApiFoto = false;
      }
    });
  }

  pesquisarBeneficio() {
    if (this.campoInputBeneficio && this.campoInputBeneficio.length > 2) {
      this.listaNomesBeneficios = null;
      this.service.getAllBeneficios(this.campoInputBeneficio).pipe(take(1)).subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            this.listaNomesBeneficios = response.response;
            this.listaNomesBeneficiosOptions = this.listaNomesBeneficios.map(beneficio => {
              return {
                value: `${beneficio.idProduto}@${beneficio.valorVendas}`,
                description: beneficio.descricaoProduto,
              };
            });
          } else {
            this.listaNomesBeneficios = false;
          }
          if (this.listaNomesBeneficios.length === 1) {
            this.unicaOpcaoBeneficio = true;
            this.campoInputBeneficio = this.listaNomesBeneficios[0].descricaoProduto;
            this.formularioBeneficio.patchValue({
              idProduto: this.listaNomesBeneficios[0].idProduto
            });
            this.defineValorUnitario(this.listaNomesBeneficios[0].valorVendas.toString());
          }
        },
        error: (erro) => {
          console.error(erro);
          this.listaNomesBeneficios = false;
        }
      });
    } else {
      this.listaNomesBeneficios = 0;
    }
  }

  limparBuscaBeneficio() {
    this.campoInputBeneficio = '';
    this.unicaOpcaoBeneficio = false;
    this.listaNomesBeneficios = undefined;
    this.formularioBeneficio.patchValue({
      valorItem: 0,
      idProduto: '',
    });
    (document.getElementById('inputValorItemBeneficio') as HTMLInputElement).disabled = false;
  }

  defineValorUnitario(valor: any) {
    if (valor && valor !== '0') {
      this.formularioBeneficio.patchValue({
        valorItem: valor,
      });
      (document.getElementById('inputValorItemBeneficio') as HTMLInputElement).disabled = true;
    } else {
      this.formularioBeneficio.patchValue({
        valorItem: valor,
      });
      (document.getElementById('inputValorItemBeneficio') as HTMLInputElement).disabled = false;
    }
  }

  // API final pra ADICIONAR ou EDITAR o beneficio
  salvarBeneficio() {
    this.alertLoading = true;
    let objBeneficio: any;
    if (this.edicaoBeneficioAtiva) {
      objBeneficio = {
        idEmpresa: this.idEmpresaLogada,
        idEmpresaUsuarioProduto: this.beneficioSelecionadoEditar.idEmpresaUsuarioProduto,
        idPeriodo: 0,
        idProduto: this.beneficioSelecionadoEditar.idProduto,
        idUsuario: this.idUsuario,
        qtdeDias: this.formularioBeneficio.value.qtdeDias,
        valorItem: this.formularioBeneficio.value.valorItem,
        qtdeDiasTrabalhados: this.formularioBeneficio.value.qtdeDiasTrabalhados,
      };
    } else {
      objBeneficio = {
        idEmpresa: this.idEmpresaLogada,
        idEmpresaUsuarioProduto: 0,
        idPeriodo: 0,
        idProduto: this.unicaOpcaoBeneficio ? this.formularioBeneficio.value.idProduto : this.formularioBeneficio.value.idProduto.split('@')[0],
        idUsuario: this.idUsuario,
        qtdeDias: this.formularioBeneficio.value.qtdeDias,
        valorItem: this.formularioBeneficio.value.valorItem,
        qtdeDiasTrabalhados: this.formularioBeneficio.value.qtdeDiasTrabalhados,

      };
    }
    this.service.createBeneficio(objBeneficio).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          this.alertSucesso = true;
          this.constroiFormularioBeneficio();
          this.limparBuscaBeneficio();
          this.mensagemErroBeneficio = '';
          this.consultaBeneficiosDoUsuario();
          this.cancelarEdicao();
        } else {
          this.alertError = true;
          this.mensagemErroBeneficio = response.mensagem;
          this.mensagemErro = response.mensagem;
        }
      },
      error: (erro: any) => {
        this.alertLoading = false;
        this.alertError = true;
        console.error(erro);
      }
    });
  }

  // Consultar beneficios do usuario
  consultaBeneficiosDoUsuario() {

    this.beneficios = null;

    this.service.getBenefitByIduser(this.idUsuario).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.beneficios = response.response.produtos;
          this.valorTotalBeneficio = response.response.valorTotal;
        } else {
          this.beneficios = false;
        }
      },
      error: (erro: any) => {
        this.beneficios = false;
        console.error(erro);
      }
    });
  }

  excluirBeneficio(idBeneficio: number) {
    this.alertLoading = true;
    this.usuarioBeneficioService.deleteBenefitById(idBeneficio).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          this.alertSucesso = true;
          this.consultaBeneficiosDoUsuario();
        } else {
          this.alertError = true;
        }
      },
      error: (erro: any) => {
        this.alertLoading = false;
        this.alertError = true;
        console.error(erro);
      }
    });
  }

  // Editar beneficio (traz os dados do beneficio pro formulario pro usuario mexer, essa funcao nao é a que envia pra API)
  editarBeneficio(beneficio: any) {
    this.beneficioSelecionadoEditar = beneficio;
    this.edicaoBeneficioAtiva = true;
    this.formularioBeneficio.patchValue({
      idPeriodo: beneficio.idPeriodo,
      idProduto: beneficio.idProduto,
      qtdeDias: beneficio.qtde,
      qtdeDiasTrabalhados: beneficio.dias,
      valorItem: Number.parseFloat(beneficio.valorUnitario.replace(',', '.')),
    });
  }

  cancelarEdicao() {
    this.beneficioSelecionadoEditar = '';
    this.edicaoBeneficioAtiva = false;
    this.mensagemErroBeneficio = '';
    this.constroiFormularioBeneficio();
  }

  abrirAlertIncluirDepartamento() {
    this.alertIncluirDepartamento = true;
  }

  eventoAlertIncluirDepartamento(evento: any) {
    if (evento === 'cancelar') {
      this.alertIncluirDepartamento = false;
    } else {
      this.alertIncluirDepartamento = evento;
      this.consultaDepartamentos();
    }
  }

  // CARGOS
  abrirAlertIncluirCargo() {
    this.alertIncluirCargo = true;
  }

  eventoAlertIncluirCargo(evento: any) {
    if (evento === 'cancelar') {
      this.alertIncluirCargo = false;
    } else {
      this.alertIncluirCargo = evento;
      this.consultaCargos();
    }
  }

  // ENDEREÇOS
  abrirAlertIncluirEndereco() {
    this.alertIncluirEndereco = true;
  }

  eventoAlertIncluirEndereco(evento: any) {
    if (evento === 'cancelar') {
      this.alertIncluirEndereco = false;
    } else {
      this.alertIncluirEndereco = evento;
      this.consultaEnderecos();
    }
  }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
  }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) {
    this.alertError = false;
  }

  // CONFIRMACAO
  abrirAlertConfirmacao(idBeneficio: number) {
    this.alertConfirmacao = true;
    this.idBeneficioParaExcluir = idBeneficio;
  }

  fecharAlertConfirmacao(evento: string) {
    if (evento === 'Confirmar') {
      this.alertConfirmacao = false;
      this.excluirBeneficio(this.idBeneficioParaExcluir);
    } else { // Se não apenas fecha o alert de confirmação e não faz nada
      this.alertConfirmacao = false;
    }
  }

  // FUNCOES SOMENTE PARA REDIRECIONAR PARA A PAGINA PASSANDO O IdUSUARIO
  navegarHistoricoCompras() {
    this.rota.navigate(['historico-compras-usuario'], {queryParams: {idUsuario: this.idUsuario}});
  }

  navegarRotaInteligente() {
    this.alertLoading = true;
    this.service.checkUserHasRotaInteligente(this.idEmpresaLogada, this.idUsuario).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          // Possui Rota Inteligente. ai envia pra Listagem de rotas
          if (response.response.possuiRoteirizacao === true) {
            this.mensagemErroRotaInteligente = '';
            this.rota.navigate(['/dados-usuario-rota-inteligente/', this.idUsuario]);
          } else {
            this.consultaExcedente();
          }
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = erro.error.mensagem;
      }
    });
  }

  consultaExcedente() {
    this.alertLoading = true;
    this.service.consultaExcedente(this.idEmpresaLogada).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          if (response.response.consultaExcedente === false) {
            this.consultaDetalheRoteirizacao();
          } else {
            this.mensagemErroRotaInteligente = '';
            this.alertPergunta = true;
          }
        }
        this.alertLoading = false;
      },
      error: (erro: any) => {
        this.alertLoading = false;
        console.error(erro);
      }
    });
  }

  consultaDetalheRoteirizacao() {
    this.alertLoading = true;
    this.service.getDetailRoteirizacao('SUGESTAO DE ROTA', this.idEmpresaLogada, this.idUsuario).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.mensagemErroRotaInteligente = '';
        this.alertLoading = false;
        if (response.status === 'OK') {
          this.detalheRoteirizacao = response.response;
          this.alertAprovarRotaInteligente = true;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = erro.error.mensagem;
      }
    });
  }

  eventoAlertPergunta(acao: string) {
    this.alertPergunta = false;
    if (acao === 'confirmar') {
      this.consultaDetalheRoteirizacao();
    }
  }

  eventoAlertRefazerRota(acao: string) {
    if (acao === 'fechar') {
      this.alertAprovarRotaInteligente = false;
    } else {
      this.alertAprovarRotaInteligente = false;
      this.alertLoading = true;
      this.aprovarRoteirizacao();
    }
  }

  aprovarRoteirizacao() {
    this.service.approvesRoteirizacao(this.idEmpresaLogada, this.detalheRoteirizacao.idRoteirizacao).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = '';
        if (response.status === 'OK') {
          this.alertSucesso = true;
        } else {
          this.mensagemErroRotaInteligente = 'Ocorreu um erro na aprovação de rota inteligente, por favor tente mais tarde.';
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertLoading = false;
        this.mensagemErroRotaInteligente = erro.error.mensagem;
      }
    });
  }

  goBackPage() {
    this.rota.navigate(['usuario-beneficio']);
  }

  solicitarSegundaVia(idProduto: number) {
    sessionStorage.abaBeneficio = true;
    this.rota.navigate(['usuario-beneficio-gerenciar-cartoes'], {queryParams: {idUsuario: this.idUsuario, idProduto}});
  }

  gerarRelatorioOpcaoVt() {
    this.service.gerarRelatorioOpcaoVt(this.idEmpresaLogada, this.idUsuario).subscribe({
      next: ({ body, headers }: HttpResponse<any>) => {
        FileDownloadService.openContentInNewWindow(body);
      },
      error: (erro: any) => {
        console.log(erro);
      }
    });
  }

  pedidoUsuario() {
    this.rota.navigate(['/fazer-pedido-avulso', this.idUsuario]);
  }

// captura o arquivo
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    const arquivo = event.target.files[0];
    this.nomeArquivo = arquivo.name;
    this.file.set('file', arquivo);
    this.comparador = arquivo.name.split('.');
    this.extensaoArquivo = '.' + this.comparador[this.comparador.length - 1];
    if (this.listaExtensoes.includes(this.extensaoArquivo.toLowerCase())) {
      this.Toastr.success(this.nomeArquivo + ' carregado com sucesso', '', {
        timeOut: 2000,
      });
    } else {
      this.Toastr.error(this.nomeArquivo + ' possui formato não permitido!', '', {
        timeOut: 2000,
      });
      this.imageChangedEvent = '';
    }
  }

// diminui o zoom da foto
  zoomOut(value) {
    this.scale = (this.tamanhoFoto / 5) * (1 - value / 1000);
    this.transform = {
      scale: this.scale
    };
  }

// aumenta o zoom da página
  zoomIn(value) {
    this.scale = (this.tamanhoFoto / 5) * (1 + value / 1000);
    this.transform = {
      scale: this.scale
    };
  }

// verifica dinamicamente se dever ser aplicado o zoomIn ou zoomOut
  scaleInOut(tamanho: any) {
    if (this.tamanhoInicio < tamanho) {
      this.zoomIn(tamanho);
      this.tamanhoInicio = tamanho;
    } else {
      this.zoomOut(tamanho);
      this.tamanhoInicio = tamanho;
    }
  }

// método que faz a verificação em tempo real das edições feitas no navegador, ele também convete o tipo do arquivo de baase64 para file
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.objectUrl;
    this.imageFile = new File([event.blob], 'foto.jpeg', { type: 'image/jpeg' });
  }

// método para avisar que a imagem carregou
  imageLoaded() {
    this.showCropper = true;
  }

// avisa quando a imagem não conseguir ser carregada
  loadImageFailed() {
    this.statusApiFoto = false;
  }

  // método base para conversão da imagem em uso
  base64ToFile(data, filename) {
    const arr = data.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.codePointAt(n);
    }
    return new File([u8arr], filename, {type: 'image/jpeg'});
  }

  verificaIdade() {
    const dataAtual: any = new Date();
    const data: any = new Date(this.formularioAba1.value.dataNascimento);
    const timeDiff = Math.abs(dataAtual.getTime() - data.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const idadeAnos = diffDays / 364;

    if (data < dataAtual) {
      if (idadeAnos > 100) {
        this.dataNascimentoInvalida = 'A idade limite deve ser menor que 100';
        this.formularioAba1.patchValue({ dataNascimento: '' });
      } else if (idadeAnos > 10) {
        this.dataNascimentoInvalida = '';
      } else {
        this.dataNascimentoInvalida = 'A idade deve ser maior do que 10 anos';
        this.formularioAba1.patchValue({ dataNascimento: '' });
      }
    } else {
      this.dataNascimentoInvalida = 'Digite uma data válida';
      this.formularioAba1.patchValue({ dataNascimento: '' });
    }

    this.habilitaBotao();
  }

  verificaHorasIdade(dataParaFormatacao: any) {
    const date = new Date(dataParaFormatacao);
    date.setHours(date.getHours() + 6);
    this.dadosUsuario.dataNascimento = date;
  }

  private getListaExtensoes() {
    this.homeService.getExtensoes('dados-usuario-editar').pipe(take(1)).subscribe({
      next: (success: any) => {
        this.listaExtensoes = success.extensions;
      },
      error: (erro: any) => {
        console.log(erro);
      }
    });
  }

  validaChavePix(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;
    const valor = inputElement.value;

    const regexCPF = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
    const regexTelefone = /^\(?\d{2}\)?.?9\d{4}.?\d{4}$/;

    this.tipoChave = '';

    if (valor.trim().length === 0) {
      this.tipoChave = '';
      this.colorChave = '';
    } else if (valor.length > 80) {
      this.tipoChave = 'A chave PIX deve conter no máximo 80 caracteres';
      this.colorChave = 'legenda-erro';
    } else if (regexTelefone.test(valor)) {
      this.tipoChave = 'Telefone';
      this.colorChave = 'legenda-chave-pix';
    } else if (EMAIL_REGEX.test(valor)) {
      this.tipoChave = 'E-mail';
      this.colorChave = 'legenda-chave-pix';
    } else if (regexCPF.test(valor)) {
      this.tipoChave = 'CPF';
      this.colorChave = 'legenda-chave-pix';
    } else {
      this.tipoChave = 'Formato incorreto';
      this.colorChave = 'legenda-erro';
    }
  }

  private getPixUsuarioHabilitado() {
    const parametro$ = this.getParametroPix();
    const atributo$ = this.getAtributoPix();

    combineLatest([parametro$, atributo$]).pipe(take(1)).subscribe(
      ([parametro, atributo]) => {
        this.pixUsuarioHabilitado = parametro && atributo;
      }
    );
  }

  private getParametroPix() {
    return this.parametroService.getParametroSistema('PIX_VT_ADMISSAO_DEVOLUCAO').pipe(
      map((dados: any) => `${dados.response}`.toLowerCase() === 'true'),
      catchError(() => of(false))
    );
  }

  private getAtributoPix() {
    return this.atributosService.getCompaniesAttributes('DEVOLUÇÃO USUÝRIO PIX', this.idEmpresaLogada).pipe(
      map((res) => res !== null),
      catchError(() => of(false))
    );
  }

}
